import { useEffect, useRef, useState } from "react";

type OrderData = {
  topBidOrderId: number | string | null;
  topBidPrice: number | null;
  topBidQuantity: number | null;
  topBidTraderCode: string | null;
  topAskOrderId: number | string | null;
  topAskPrice: number | null;
  topAskQuantity: number | null;
  topAskTraderCode: string | null;
};

export function useOrderFlashing(orderData: OrderData): boolean {
  const [isFlashing, setIsFlashing] = useState(false);
  const prevSignatureRef = useRef<string | null>(null);
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    const signature = [
      orderData.topBidOrderId,
      orderData.topBidPrice,
      orderData.topBidQuantity,
      orderData.topBidTraderCode,
      orderData.topAskOrderId,
      orderData.topAskPrice,
      orderData.topAskQuantity,
      orderData.topAskTraderCode,
    ]
      .map((value) => (value ?? ""))
      .join("|");

    if (prevSignatureRef.current !== null && prevSignatureRef.current !== signature) {
      setIsFlashing(true);
      if (timeoutRef.current !== null) {
        window.clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = window.setTimeout(() => {
        setIsFlashing(false);
        timeoutRef.current = null;
      }, 500);
    }
    prevSignatureRef.current = signature;

    return () => {
      if (timeoutRef.current !== null) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, [
    orderData.topAskOrderId,
    orderData.topAskPrice,
    orderData.topAskQuantity,
    orderData.topAskTraderCode,
    orderData.topBidOrderId,
    orderData.topBidPrice,
    orderData.topBidQuantity,
    orderData.topBidTraderCode,
  ]);

  return isFlashing;
}
